import type { AuthChangeEvent } from '@supabase/supabase-js';
import type { QueryClient } from '@tanstack/react-query';

export const CURRENT_ENTITLEMENTS_QUERY_KEY = ['entitlements', 'current'] as const;

export function currentEntitlementsQueryKey(userId?: string | null) {
    return [...CURRENT_ENTITLEMENTS_QUERY_KEY, userId || 'session-pending'] as const;
}

export function shouldClearEntitlementsForAuthEvent(event: AuthChangeEvent): boolean {
    return event === 'SIGNED_IN'
        || event === 'SIGNED_OUT'
        || event === 'TOKEN_REFRESHED'
        || event === 'USER_UPDATED';
}

/**
 * Auth transitions can change entitlement identity without changing the user
 * id, for example when an anonymous account is confirmed in place. Session
 * handling invalidates the module snapshot first, then calls this function to
 * retire every React Query entry from the prior auth generation.
 */
export function clearCurrentEntitlementQueries(queryClient: QueryClient): void {
    void queryClient.cancelQueries({
        queryKey: CURRENT_ENTITLEMENTS_QUERY_KEY,
        exact: false,
    });
    queryClient.removeQueries({
        queryKey: CURRENT_ENTITLEMENTS_QUERY_KEY,
        exact: false,
    });
}
